export enum RescueConstants {
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'rescue/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'rescue/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  SET_TYPES = 'rescue/SET_TYPES',
  SET_HYDRAULICS = 'rescue/SET_HYDRAULICS',
  SET_TOOLS = 'rescue/SET_TOOLS',
  SET_REHAB = 'rescue/SET_REHAB',
  SET_ACTIVATIONS = 'rescue/SET_ACTIVATIONS',
  SET_SIZE = 'rescue/SET_SIZE',
  SET_RESPONSE = 'rescue/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'rescue/SET_RESPONSE_PNNV',
  SAVE_RESCUE = 'rescue/SAVE_RESCUE',
  RESET_STATE = 'rescue/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'rescue/SET_ADD_TO_TIMELINE',
  SET_STATE = 'rescue/SET_STATE',
  SET_DATE_TIME = 'rescue/SET_DATE_TIME',
  SET_ASSESSED_BY = 'rescue/SET_ASSESSED_BY',
  ON_SELECT_RESCUE = 'rescue/ON_SELECT_RESCUE',
  SET_UPDATE_INPUT_ROWS = 'rescue/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'rescue/SET_DATE',
  SET_TIME = 'rescue/SET_TIME',
  SET_ATTEMPTS = 'rescue/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'rescue/SET_PROCEDURE_COMPLICATIONS',
  SET_AUTHORIZATION = 'rescue/SET_AUTHORIZATION',
  SET_SUCCESSFUL_ATTEMPT = 'rescue/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'rescue/SET_PTA',
  SET_COMMENTS = 'rescue/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'rescue/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'rescue/SET_ROLE_PERFORMING_PNNV',
}
